import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '@pflegix/config';
import { HttpClientService } from '@pflegix/http-client';
import { BusinessPartnerResponseDto } from '@pflegix/types';
import { Observable } from 'rxjs';

enum OrderFormTopic {
  CAREGIVERS_OF_ORGANIZATION = 'caregivers-of-organization',
}

@Injectable()
export class OrderFormApi {
  private readonly config = inject(ConfigurationService);
  private readonly httpClient = inject(HttpClientService);

  public getCaregiversOfOrganization(id: string): Observable<BusinessPartnerResponseDto[]> {
    return this.httpClient.get<BusinessPartnerResponseDto[]>(
      `${this.apiUrl}/business-partners/${id}/caregivers`,
      this.httpClient.buildResilienceConfigForTopic(OrderFormTopic.CAREGIVERS_OF_ORGANIZATION)
    );
  }

  private get apiUrl(): string {
    return `${this.config.get('basePflegixApiUrl')}/api`;
  }
}
